<app-header></app-header>
<div class="container-xxl">
  <!-- START CAROUSEL -->
  <div class="slideshow">
    <div class="slideshow-item">
        <img src="https://getwallpapers.com/wallpaper/full/d/9/5/1051419-cool-quran-wallpaper-2560x1600-lockscreen.jpg" alt="">
        <!-- <div class="center-text slideshow-item-text">
          <p class="first">قال رسول الله صلى الله عليه و سلم:-</p>
          <p class="second">"خَيْرُكُمْ مَن تَعَلَّمَ القُرْآنَ وعَلَّمَهُ"</p>
          <p class="third">رواه: البخاري</p>
        </div> -->
    </div>

    <div class="slideshow-item">
      <img src="http://4.bp.blogspot.com/-Mr04ESJZNtw/VPxXFObmZoI/AAAAAAAAAd4/q5Cbdp_3pbo/s1600/IMG_8499.JPG" alt="">
      <div class="right-text slideshow-item-text">
          <div class="inside">
            <h2>خَيْرُكُمْ</h2>
            <p>يمكنك أن تدرس حيث كنت وفق أحدث الطرق الدراسية</p>
            <p>
              تعليم مصور – مقاطع فيديو – مقاطع صوت – مقاطع موشن جرافيك. -حلقات مباشرة على برامج البث 
            </p>
          </div>
      </div>
    </div>

    <div class="slideshow-item">
      <img src="http://4.bp.blogspot.com/-h5DLzedweXk/Tyqu3xKpqVI/AAAAAAAAAIw/CKaq45dIc9k/s1600/IMG_8551.jpg" alt="">      
      <div class="right-text slideshow-item-text">
          <div class="inside">
            <h2>سجل الآن</h2>
            <p>التسجيل متاح حتى اكتمال العدد</p>
            <p>إدارة خيركم</p>
          </div>
      </div>
    </div>
</div>
  <!-- End CAROUSEL -->

  <!-- Start About-Us -->
  <section class="about-us bg-white">
    <div class="container">
      <div class="row d-flex justify-content-center align-items-center">
        <div class="text mt-5 col-sm-6" data-aos="fade-left" data-aos-duration="2000">
          <p class="welcome"> مرحباً بكم في خَيْرُكُمْ </p>
          <h2 class="title">نبذة تعريفية  </h2>
          <p class="start mt-4"> " بِسْمِ اللَّـهِ الرَّحْمَـٰنِ الرَّحِيمِ " </p>
          <p class="text-body">قال تعالى "ثم أورثنا الكتاب الذين اصطفينا من عبادنا" <br>وقال رسولنا صلى الله عليه وسلم"خيركم من تعلم القرآن وعلمه"..<br> من هنا انطلقت منصتنا  "خيركم" <br>و هي منصة إلكترونية تعني بتدريس القرآن  الكريم </p>
          <p class="text-body"> بمجرد تسجيلك في خيركم يصبح لديك حساب مزدوج الصلاحية يمكنك أن تكون طالبا في دورة تدريبية وفي نفس الوقت معلم لأخرى <br><small class="text-warning">(ملحوظة :المعلم يشترط له اجتياز المقابلة)</small><br>يسعدنا أن تلحق بهذا الركب المبارك بالضغط على زر التسجيل  </p>
          <a class="more btn mt-2"routerLink ="/register">سجل الآن</a>
        </div>
        
        <div class="photo text-center mt-5 mb-5 col-sm-6" data-aos="fade-up" data-aos-duration="2000">          
            <img class="img-fluid mt-5 mb-5" src="assets/images/about-us-image.PNG">          
        </div>        
      </div>
    </div>
  </section>
  <!-- End About-Us -->

  <!-- Start Category -->
  <section id="category" class="ftco-section category mt-5">
    <div class="container">
      <div class="row justify-content-center pb-4">
        <div class="col-md-12 heading-section text-center ftco-animate" data-aos="zoom-in" data-aos-duration="2000">
          <h2 class="title mb-4 mt-5">الأقسام</h2>
        </div>
      </div>
      <div>
        <app-index-category></app-index-category>
      </div>
      <div class="col-md-12 text-center mt-5" data-aos="flip-down" data-aos-duration="2000">
        <a routerLink="/getAllCategories" class="button btn btn-light mb-5">لمزيد من الأقسام</a>
      </div>      
    </div>
  </section>
  <!-- End Category -->

  <!-- Start PILLARS-OF-ISLAM -->
  <section class="pillars mt-5">
    <div class="container">
      <h2 class="text-center mb-5 pt-5" data-aos="zoom-in" data-aos-duration="2000">من نوايا دراسة القرآن الكريم</h2>
      <div class="content row pb-4 d-flex justify-content-center align-items-center">
        <div class="col-sm-2 text-center mb-4" data-aos="flip-right" data-aos-duration="2000">
          <div class="image">
            <img class="img-fluid" src="assets/images/kalma-image.PNG">
          </div>          
          <div class="title">
            <h3>تعزيز التوحيد</h3>
          </div>
        </div>

        <div class="col-sm-2 text-center mb-4" data-aos="flip-right" data-aos-duration="2000">
          <div class="image">
            <img class="img-fluid" src="assets/images/salat-image.PNG">
          </div>          
          <div class="title">
            <h3>تحقيق العبودية</h3>
          </div>
        </div>

        <div class="col-sm-2 text-center mb-4" data-aos="flip-right" data-aos-duration="2000">
          <div class="image">
            <img class="img-fluid" src="assets/images/zahat-image.PNG">
          </div>          
          <div class="title">
            <h3>تفريج الهم </h3>
          </div>
        </div>

        <div class="col-sm-2 text-center mb-4" data-aos="flip-right" data-aos-duration="2000">
          <div class="image">
            <img class="img-fluid" src="assets/images/fasting-image.PNG">
          </div>          
          <div class="title">
            <h3>زيادة الأجر</h3>
          </div>
        </div>

        <div class="col-sm-2 text-center mb-4" data-aos="flip-right" data-aos-duration="2000">
          <div class="image">
            <img class="img-fluid" src="assets/images/hajj-image.PNG">
          </div>          
          <div class="title">
            <h3>الرفعة في الدارين</h3>
          </div>
        </div>
        <div class="col-sm-2 text-center mb-4" data-aos="flip-right" data-aos-duration="2000">
          <div class="image">
            <img class="img-fluid" src="assets/images/hajj-image.PNG">
          </div>          
          <div class="title">
            <h3>لأكون من أهل القرآن</h3>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- End PILLARS-OF-ISLAM -->

  <section id="course" class="ftco-section course mt-5">
    <div class="container">
      <div class="row justify-content-center pb-4">
        <div class="col-md-12 heading-section text-center ftco-animate" data-aos="zoom-in" data-aos-duration="2000">
          <h2 class="title mb-5 mt-5">الدورات التدريبية</h2>
        </div>
      </div>
      <div>
        <app-index-course></app-index-course>
        <div class="col-md-12 text-center mt-5" data-aos="flip-down" data-aos-duration="2000">
          <a routerLink="/getAllCourses" class="button btn btn-outline-light mb-5">لمزيد من الدورات التدريبية</a>
        </div>
      </div>
    </div>
  </section> 

  <!-- STORE-OPINOINS section starts -->
  <div class="carousel mt-5">
    <div class="container">
      <h2 class="text-center pt-5" data-aos="zoom-in" data-aos-duration="2000">قالوا عنا</h2>
      <div id="carouselExampleControls" class="carousel slide mt-5" data-ride="carousel">
        <div class="carousel-inner text-center">
          <div class="carousel-item active ">
            <div class="image">
              <img class="img-fluid" src="https://image.freepik.com/free-photo/muslim-woman-pray-with-beads-read-quran_73740-688.jpg" width="100">
            </div>
            <div class="title mt-4 font-weight-bold">خَيْرُكُمْ</div>
              <p class="mt-4 mb-5">هذا النص يمكن استبداله بنص اخر بديل  هذا النص يمكن استبداله بنص اخر بديل هذا النص يمكن استبداله بنص اخر بديلر هذا النص يمكن استبداله بنص اخر بديل هذا النص يمكن استبداله بنص اخر بديل ر هذا النص يمكن استبداله بنص اخر بديل هذا النص يمكن استبداله بنص اخر بديل هذا النص يمكن استبداله بنص اخر بديل هذا النص يمكن استبداله بنص اخر بديل </p> 
          </div>
          <div class="carousel-item">
            <div class="image">
              <img class="img-fluid" src="https://image.freepik.com/free-photo/muslim-woman-pray-with-beads-read-quran_73740-688.jpg" width="100">
            </div>
            <div class="title mt-4 font-weight-bold">خَيْرُكُمْ</div>
              <p class="mt-4 mb-5">هذا النص يمكن استبداله بنص اخر بديل  هذا النص يمكن استبداله بنص اخر بديل هذا النص يمكن استبداله بنص اخر بديلر هذا النص يمكن استبداله بنص اخر بديل هذا النص يمكن استبداله بنص اخر بديل ر هذا النص يمكن استبداله بنص اخر بديل هذا النص يمكن استبداله بنص اخر بديل هذا النص يمكن استبداله بنص اخر بديل هذا النص يمكن استبداله بنص اخر بديل </p> 
          </div>
          <div class="carousel-item">
            <div class="image">
              <img class="img-fluid" src="https://image.freepik.com/free-photo/muslim-woman-pray-with-beads-read-quran_73740-688.jpg" width="100">
            </div>
            <div class="title mt-4 font-weight-bold">خَيْرُكُمْ</div>
              <p class="mt-4 mb-5">هذا النص يمكن استبداله بنص اخر بديل  هذا النص يمكن استبداله بنص اخر بديل هذا النص يمكن استبداله بنص اخر بديلر هذا النص يمكن استبداله بنص اخر بديل هذا النص يمكن استبداله بنص اخر بديل ر هذا النص يمكن استبداله بنص اخر بديل هذا النص يمكن استبداله بنص اخر بديل هذا النص يمكن استبداله بنص اخر بديل هذا النص يمكن استبداله بنص اخر بديل </p> 
          </div>
        </div>
        <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
          <span class="arrows mb-5"><i class="fas fa-chevron-left"></i></span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
          <span class="arrows mb-5"><i class="fas fa-chevron-right"></i></span>
        </a>
      </div>
    </div>
  </div>
  <!-- End Opinion -->

  <!-- START CONTACT -->
  <div class="contact-us">
    <div class="container" id="contact">            
      <!-- <iframe src="https://mapcarta.com/Cairo/Map" width="100%" height="400px"></iframe> -->
      <div class="row d-flex justify-content-around">
        <div class="form col-sm-6 mt-5 mb-5" data-aos="fade-up" data-aos-duration="2000"> 
          <h2 class="title">تواصل معانا</h2>         
          <p class="mt-4">هل لديك أسئلة حول برامج أو خدمات خيرُكُم ؟ دعنا نساعد.<br>استخدم نموذج الاتصال الخاص بنا وسنعاود الاتصال بك في أقرب وقت ممكن.</p>
          <form [formGroup]="addForm" enctype="multipart/form-data">
            <input formControlName="senderName" type="text" class="form-control mt-4" id="exampleFormControlInput1" placeholder="الاسم">
            <input formControlName="email" type="email" class="form-control mt-3" id="exampleFormControlInput1" placeholder="البريد الإلكتروني">
            <textarea formControlName="message" class="form-control mt-3" id="exampleFormControlTextarea1" rows="6" placeholder="اكتب رسالتك..."></textarea>
            <button type="submit" class="btn btn-outline-light mt-3"   (click)="submit()"> إرسال </button>
          </form>
        </div>
        
        <div class="info col-sm-4 mt-5 mb-5" data-aos="fade-right" data-aos-duration="2000">
          <h3 class="mt-5">معلومات للتواصل</h3>
          <div class="row mt-4">
            <i class="fas fa-map-marker-alt col-2"></i>&nbsp; &nbsp;
            <p> القاهرة ، مصر </p>
          </div>
          
          <div class="row mt-3">
            <i class="fas fa-phone col-2"></i>&nbsp; &nbsp;
            <p>010111111111 <br> 011000000000</p>
          </div>

          <div class="row mt-3">
            <i class="fas fa-envelope col-2"></i>&nbsp; &nbsp;
            <p>khairokom@gmail.com</p>
          </div>

          <div class="row mt-3">
            <i class="fas fa-globe col-2"></i>&nbsp; &nbsp;
            <p>www.khairokom.com</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END CONTACT -->
</div>
<app-footer></app-footer>